import _objectWithoutProperties from "/home/runner/work/muhrusdi.github.io/muhrusdi.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/runner/work/muhrusdi.github.io/muhrusdi.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/muhrusdi.github.io/muhrusdi.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["as"],
    _excluded2 = ["forceMount"],
    _excluded3 = ["children", "aria-label", "portalled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useId as e } from "@radix-ui/react-id";
import * as t from "@radix-ui/react-visually-hidden";
import { Slottable as o } from "@radix-ui/react-slot";
import { Portal as n } from "@radix-ui/react-portal";
import * as r from "@radix-ui/react-popper";
import { extendPrimitive as i } from "@radix-ui/react-primitive";
import { Presence as a } from "@radix-ui/react-presence";
import { useRect as s } from "@radix-ui/react-use-rect";
import { usePrevious as l } from "@radix-ui/react-use-previous";
import { useLayoutEffect as c } from "@radix-ui/react-use-layout-effect";
import { useEscapeKeydown as u } from "@radix-ui/react-use-escape-keydown";
import { useControllableState as p } from "@radix-ui/react-use-controllable-state";
import { createContext as d } from "@radix-ui/react-context";
import { useComposedRefs as m } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as f } from "@radix-ui/primitive";
import * as g from "react";
import E from "@babel/runtime/helpers/esm/extends";

function x(e) {
  return {
    type: "machine.actions.assign",
    assign: e
  };
}

var y, T;

var C = x(function (e, t) {
  var o;
  return _objectSpread(_objectSpread({}, e), {}, {
    id: null !== (o = t.id) && void 0 !== o ? o : e.id
  });
}),
    v = function (e) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$debug = _ref.debug,
      t = _ref$debug === void 0 ? !1 : _ref$debug,
      _ref$warnOnUnknownTra = _ref.warnOnUnknownTransitions,
      o = _ref$warnOnUnknownTra === void 0 ? !1 : _ref$warnOnUnknownTra;

  var n = e.initial,
      r = e.context;

  var i = [],
      a = function a(s) {
    var l, c;
    var u = e.states[n],
        p = s.type,
        d = null === (l = e.on) || void 0 === l ? void 0 : l[p],
        m = null === (c = u.on) || void 0 === c ? void 0 : c[p],
        f = null != d ? d : m;
    if (void 0 === f) o && console.warn("From state: \"".concat(n, "\", event \"").concat(p, "\" has no transition to any state"));else {
      var _o = f.target,
          _f$actions = f.actions,
          _l = _f$actions === void 0 ? [] : _f$actions,
          _f$cond = f.cond,
          _c = _f$cond === void 0 ? function () {
        return !0;
      } : _f$cond,
          _p = _o ? e.states[_o] : {};

      if (_c(r, s)) {
        var _e = (u.exit || []).concat(_l, _p.entry || []);

        r = function (e, t, o) {
          var n = o;
          return null == e || e.forEach(function (e) {
            "function" == typeof e ? e(n, t, a) : "machine.actions.assign" === e.type && (n = e.assign(n, t));
          }), n;
        }(_e, s, r), _o && (n = _o, t && (console.group("event:", s), console.log("state:", n), console.log("context:", r), console.groupEnd()), i.forEach(function (e) {
          return e({
            state: n,
            context: r
          });
        }));
      }
    }
  };

  return {
    subscribe: function subscribe(e) {
      return i.push(e), function () {
        i.splice(i.indexOf(e), 1);
      };
    },
    send: a,
    getContext: function getContext() {
      return r;
    }
  };
}({
  initial: "closed",
  context: {
    id: null,
    delayed: !1
  },
  on: {
    FOCUS: {
      target: "open"
    }
  },
  states: {
    closed: {
      entry: [x(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          id: null
        });
      })],
      on: {
        OPEN: {
          target: "opening"
        }
      }
    },
    opening: {
      entry: [function (e, t, o) {
        var n = t.delayDuration,
            r = function r() {
          return o({
            type: "DELAY_TIMER_END"
          });
        };

        void 0 === n ? r() : y = window.setTimeout(r, n);
      }, C, x(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          delayed: !0
        });
      })],
      exit: [function () {
        return clearTimeout(y);
      }],
      on: {
        DELAY_TIMER_END: {
          target: "open"
        },
        CLOSE: {
          target: "closed"
        }
      }
    },
    open: {
      entry: [C],
      exit: [x(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          delayed: !1
        });
      })],
      on: {
        OPEN: {
          target: "open"
        },
        CLOSE: {
          target: "closing",
          cond: function cond(e, t) {
            return e.id === t.id;
          }
        }
      }
    },
    closing: {
      entry: [function (e, t, o) {
        var n;
        var r = null !== (n = t.skipDelayDuration) && void 0 !== n ? n : 300;
        T = window.setTimeout(function () {
          return o({
            type: "SKIP_DELAY_TIMER_END"
          });
        }, r);
      }],
      exit: [function () {
        return clearTimeout(T);
      }],
      on: {
        OPEN: {
          target: "open"
        },
        SKIP_DELAY_TIMER_END: {
          target: "closed"
        }
      }
    }
  }
}),
    _d = d("Tooltip"),
    _d2 = _slicedToArray(_d, 2),
    b = _d2[0],
    D = _d2[1];

export var Tooltip = function Tooltip(t) {
  var o = t.children,
      n = t.open,
      _t$defaultOpen = t.defaultOpen,
      i = _t$defaultOpen === void 0 ? !1 : _t$defaultOpen,
      a = t.onOpenChange,
      _t$delayDuration = t.delayDuration,
      s = _t$delayDuration === void 0 ? 700 : _t$delayDuration,
      _t$skipDelayDuration = t.skipDelayDuration,
      l = _t$skipDelayDuration === void 0 ? 300 : _t$skipDelayDuration,
      _g$useState = g.useState(null),
      _g$useState2 = _slicedToArray(_g$useState, 2),
      u = _g$useState2[0],
      d = _g$useState2[1],
      m = e(),
      _p2 = p({
    prop: n,
    defaultProp: i,
    onChange: a
  }),
      _p3 = _slicedToArray(_p2, 2),
      _p3$ = _p3[0],
      f = _p3$ === void 0 ? !1 : _p3$,
      E = _p3[1],
      _g$useState3 = g.useState(n ? "instant-open" : "closed"),
      _g$useState4 = _slicedToArray(_g$useState3, 2),
      x = _g$useState4[0],
      y = _g$useState4[1];

  g.useEffect(function () {
    return v.subscribe(function (_ref2) {
      var e = _ref2.state,
          t = _ref2.context;
      "open" === e && t.id === m ? E(!0) : E(!1);
    });
  }, [m, E]), g.useEffect(function () {
    return v.subscribe(function (_ref3) {
      var e = _ref3.state,
          t = _ref3.context;
      t.id === m ? y("open" === e ? t.delayed ? "delayed-open" : "instant-open" : "closed") : y("closed");
    });
  }, [m]);
  var T = g.useCallback(function () {
    return v.send({
      type: "FOCUS",
      id: m
    });
  }, [m]),
      C = g.useCallback(function () {
    return v.send({
      type: "OPEN",
      id: m,
      delayDuration: s
    });
  }, [m, s]),
      D = g.useCallback(function () {
    return v.send({
      type: "CLOSE",
      id: m,
      skipDelayDuration: l
    });
  }, [l, m]);
  return g.useEffect(function () {
    return function () {
      return D();
    };
  }, [D]), c(function () {
    !0 === n && v.send({
      type: "OPEN",
      id: m
    });
  }, [m, n]), /*#__PURE__*/g.createElement(r.Root, null, /*#__PURE__*/g.createElement(b, {
    contentId: m,
    open: f,
    stateAttribute: x,
    trigger: u,
    onTriggerChange: d,
    onFocus: T,
    onOpen: C,
    onClose: D
  }, o));
};
/*#__PURE__*/

var w = "button";
export var TooltipTrigger = /*#__PURE__*/g.forwardRef(function (e, t) {
  var _e$as = e.as,
      o = _e$as === void 0 ? w : _e$as,
      n = _objectWithoutProperties(e, _excluded),
      i = D("TooltipTrigger"),
      a = m(t, function (e) {
    return i.onTriggerChange(e);
  });
  /*#__PURE__*/


  return g.createElement(r.Anchor, E({
    type: "button",
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, n, {
    as: o,
    ref: a,
    onMouseEnter: f(e.onMouseEnter, i.onOpen),
    onMouseLeave: f(e.onMouseLeave, i.onClose),
    onMouseDown: f(e.onMouseDown, i.onClose),
    onFocus: f(e.onFocus, i.onFocus),
    onBlur: f(e.onBlur, i.onClose),
    onKeyDown: f(e.onKeyDown, function (e) {
      "Enter" !== e.key && " " !== e.key || i.onClose();
    })
  }));
});
/*#__PURE__*/

export var TooltipContent = /*#__PURE__*/g.forwardRef(function (e, t) {
  var o = e.forceMount,
      n = _objectWithoutProperties(e, _excluded2),
      r = D("TooltipContent");
  /*#__PURE__*/


  return g.createElement(a, {
    present: o || r.open
  }, /*#__PURE__*/g.createElement(h, E({
    ref: t
  }, n)));
});
var h = /*#__PURE__*/g.forwardRef(function (e, i) {
  var a = e.children,
      s = e["aria-label"],
      _e$portalled = e.portalled,
      l = _e$portalled === void 0 ? !0 : _e$portalled,
      c = _objectWithoutProperties(e, _excluded3),
      p = D("TooltipContent"),
      d = l ? n : g.Fragment;

  return u(function () {
    return p.onClose();
  }), /*#__PURE__*/g.createElement(d, null, /*#__PURE__*/g.createElement(O, null), /*#__PURE__*/g.createElement(r.Content, E({
    "data-state": p.stateAttribute
  }, c, {
    ref: i,
    style: _objectSpread(_objectSpread({}, c.style), {}, {
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)"
    })
  }), /*#__PURE__*/g.createElement(o, null, a), /*#__PURE__*/g.createElement(t.Root, {
    id: p.contentId,
    role: "tooltip"
  }, s || a)));
});
/*#__PURE__*/

export var TooltipArrow = i(r.Arrow, {
  displayName: "TooltipArrow"
});

function O() {
  var e = D("CheckTriggerMoved"),
      t = s(e.trigger),
      o = null == t ? void 0 : t.left,
      n = l(o),
      r = null == t ? void 0 : t.top,
      i = l(r),
      a = e.onClose;
  return g.useEffect(function () {
    (void 0 !== n && n !== o || void 0 !== i && i !== r) && a();
  }, [a, n, i, o, r]), null;
}

export var Root = Tooltip;
export var Trigger = TooltipTrigger;
export var Content = TooltipContent;
export var Arrow = TooltipArrow;